module.exports = __webpack_public_path__ + "img/11.c92974dd.jpg";